import React, { FC } from "react";
import { AdminChildSelectBlock, AdminChildSelectItem, AdminChildSelectItems, AdminChildSelectValue } from "./AdminChildSelectStyles";
import useModal from "../../../hooks/useModal";
import useOutsideClick from "../../../hooks/useOutsideClick";

interface IAdminChildSelect {
  value: string | null;
  values: string[];
  placeholder: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const AdminChildSelect: FC<IAdminChildSelect> = ({ value, values, onChange, placeholder, disabled = false }) => {
  const [selectOpen, openSelect, closeSelect] = useModal();

  const ref = useOutsideClick(closeSelect);

  const changeSelect = (value: string) => {
    if (disabled) return;

    onChange(value);
    closeSelect();
  };

  const toggleSelect = () => {
    if (disabled) return;

    selectOpen ? closeSelect() : openSelect();
  };

  return (
    <AdminChildSelectBlock ref={ref}>
      <AdminChildSelectValue type="button" onClick={toggleSelect} isPlaceholder={!value} disabled={disabled}>
        {value || placeholder}
      </AdminChildSelectValue>
      {selectOpen && (
        <AdminChildSelectItems>
          {values.map((value) => {
            return (
              <AdminChildSelectItem key={value} onClick={() => changeSelect(value)}>
                {value}
              </AdminChildSelectItem>
            );
          })}
        </AdminChildSelectItems>
      )}
    </AdminChildSelectBlock>
  );
};

export default AdminChildSelect;
